import { Pipe, PipeTransform } from '@angular/core';
function timeago(differtime: number, args: number = 5): string {
  const currentYear: number = new Date().getFullYear(); // 获取当前的年份
  const TimetoSecond: any = {
    year: new Date(`${currentYear}`).getTime() / 1000,
    month: 30 * 86400,
    day: 86400,
    hour: 3600,
    minute: 60,
  };
  if (differtime >= TimetoSecond.year) {
    return parseInt(`${differtime / TimetoSecond.year}`, 10) + '年前';
  }
  if (differtime >= TimetoSecond.month) {
    return parseInt(`${differtime / TimetoSecond.month}`, 10) + '月前';
  }
  if (differtime >= TimetoSecond.day) {
    return parseInt(`${differtime / TimetoSecond.day}`, 10) + '天前';
  }
  if (differtime >= TimetoSecond.hour) {
    return parseInt(`${differtime / TimetoSecond.hour}`, 10) + '小时前';
  }
  if (differtime >= TimetoSecond.minute) {
    return parseInt(`${differtime / TimetoSecond.minute}`, 10) + '分钟前';
  }
  if (differtime < args) {
    return '片刻之前';
  } else {
    return parseInt(`${differtime}`, 10) + '秒前';
  }
}
@Pipe({
  name: 'longTimeAgo'
})
export class LongTimeAgoPipe implements PipeTransform {
  /**
   *
   * @param value 可以处理的值是字符串(能转为数字的)或者数字
   * @param args  传入默认多少之后才进行处理,在此之前都是片刻
   */
  transform(value: any, args?: any): any {
    // 获取今天的时间戳,并得到秒数
    const currentTimeStamp: number = new Date().getTime();
    if (value) {
      let paramTimestamp = 0; // 传入的时间戳
      if (typeof value === 'string') {
        const intValue = parseInt(value, 10);
        paramTimestamp = new Date(intValue).getTime();
        if (Number.isNaN(paramTimestamp)) {
          return null;
        }
      }
      if (typeof value === 'number') {
        paramTimestamp = new Date(value).getTime();
      }
      const DifferTime = (currentTimeStamp - paramTimestamp) / 1000;
      return timeago(DifferTime, args);
    } else {
      // 否则返回原值
      return null;
    }
  }

}
